import { CircularProgress, TextField, Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'react-layout-components';
import { withRouter } from 'react-router-dom';
import FadeFromDown from '../transitions/FadeFromDown';
import Button from './Button';
import Spacing from './Spacing';


class ContactForm extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            email: '',
            emailError: false,
            name: '',
            nameError: false,
            message: '',
            dirty: false,
            mailSent: false,
            mailSentFail: false,
            loading: false
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    doSendEmail = async () => {

        const { email, emailError, name, nameError, message } = this.state

        if (!emailError && !nameError) {

            await this.asyncSetState({ loading: true })

            try {
                fetch('https://us-central1-portfolio-9eaa3.cloudfunctions.net/sendMail', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        subject: "Contato - " + name,
                        to: email,
                        body: message || 'Olá, estou entrando em contato pelo site. Pode retornar este email?'
                    }),
                }).then(() => {
                    this.asyncSetState({ loading: false, mailSent: true })
                }).catch(() => {
                    this.asyncSetState({ loading: false, mailSentFail: true })
                });
            } catch (error) {
                await this.asyncSetState({ loading: false, mailSentFail: true })
            }
        }
    }

    doChangeEmail = (email) => {
        const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const emailError = (email && emailReg.test(email)) ? false : 'Seu Email (email inválido)'
        this.setState({ ...this.state, emailError, email, dirty: true })
    }

    doChangeName = (name) => {
        const nameError = name ? false : 'Seu Email (email inválido)'
        this.setState({ ...this.state, nameError, name, dirty: true })
    }

    render() {

        const { classes } = this.props
        const { emailError, nameError, dirty, email, name, loading, mailSent, mailSentFail } = this.state

        return (
            <Box className={classes.root} column>

                {
                    loading && (
                        <Box className={classes.loading} column center>
                            <CircularProgress size={56} />
                        </Box>
                    )
                }

                {
                    mailSent && (
                        <Box className={classes.message} column center>
                            <Typography variant={'title'} className={classes.messageSuccess} align={'center'}>Mensagem Enviada!</Typography>
                        </Box>
                    )
                }

                {
                    mailSentFail && (
                        <Box className={classes.message} column center>
                            <Typography variant={'title'} className={classes.messageError} align={'center'}>Oops! Não foi possível enviar sua mensagem! Use um dos meios de contato acima.</Typography>
                        </Box>
                    )
                }

                <FadeFromDown visible={!loading && !mailSent && !mailSentFail}>
                    <Box className={classes.form} column>
                        <TextField label={emailError || 'Seu Email'}
                            name="email"
                            error={!!emailError}
                            value={this.state.email}
                            onChange={({ target: { value } }) => this.doChangeEmail(value)} />

                        <Spacing vertical />
                        <TextField label={nameError || 'Nome'}
                            name="name"
                            error={!!nameError}
                            value={this.state.name}
                            onChange={({ target: { value } }) => this.doChangeName(value)} />

                        <Spacing vertical />
                        <TextField label={'Mensagem (opcional)'} multiline rows={2}
                            value={this.state.message}
                            onChange={({ target: { value } }) => this.setState({ ...this.state, message: value })} />

                        <Spacing vertical large />
                        <Button
                            disabled={
                                !!(!dirty || emailError || nameError) || !name || !email
                            } variant={'contained'} color={'primary'} onClick={this.doSendEmail}>Enviar</Button>
                    </Box>
                </FadeFromDown>
            </Box>
        )
    }

}

ContactForm.propTypes = {
    classes: PropTypes.any,
    light: PropTypes.bool,
    elevated: PropTypes.bool
}

const styles = theme => ({
    root: {
        position: 'relative',
        minWidth: 360,
        padding: theme.spacing.unit * 2
    },
    loading: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    form: {
        backgroundColor: '#FFFFFF'
    },
    message: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#FFFFFF',
    },
    messageSuccess: {
        color: theme.palette.green['500']
    },
    messageError: {
        color: theme.palette.red['500']
    }
})

export default withRouter(withStyles(styles)(ContactForm))


// WEBPACK FOOTER //
// ./src/components/common/ContactForm.js